import { Stack, Typography } from '@mui/material';

const plans = [
  {
    label: 'Free',
    content: [
      // NOTE Toss payment 심사를 위해 주석처리
      // '데이터 저장 기간 : 30일',
      '실시간 온도 / 위치 모니터링',
      '알람기능(App PUSH, E-mail)',
      '데이터 다운로드(PDF)',
      '인터벌 조절 가능',
      '1년 무상 A/S',
      '사용자 1인',
    ],
    rateText: ['무료'],
  },
  {
    label: 'Basic',
    content: [
      // NOTE Toss payment 심사를 위해 주석처리
      // '데이터 저장 기간 : 2년',
      '실시간 온도 / 위치 모니터링',
      '알람기능(SMS 10건/월, App PUSH, E-mail)',
      '데이터 다운로드(PDF)',
      '인터벌 조절 가능',
      '1년 무상 A/S',
    ],
    rateText: ['18,000원/년', '2,300원/월'],
  },
  {
    label: 'Premium',
    content: [
      // NOTE Toss payment 심사를 위해 주석처리
      // '데이터 저장 기간 : 5년',
      '실시간 온도 / 위치 모니터링',
      '알람기능(SMS 30건/월, App PUSH, E-mail)',
      '데이터 다운로드(PDF)',
      '인터벌 조절 가능',
      '1년 무상 A/S',
      '21 CFR part 11',
      'API 지원',
    ],
    rateText: ['45,000원/년', '4,500원/월'],
  },
];

interface PlanCardProps {
  title: string;
  content: string[];
  rate: string[];
}
function PlanCard({ title, content, rate }: PlanCardProps) {
  return (
    <Stack gap={3} sx={{ width: 280, boxShadow: 2, p: 2 }}>
      <Typography variant="h5" fontWeight="bold" textAlign="center" color="primary">
        {title}
      </Typography>
      <Stack>
        {content.map((text, i) => (
          <Typography key={'content' + i} fontWeight={i === 0 ? 'bold' : ''}>
            {`${i + 1}) ${text}`}
          </Typography>
        ))}
      </Stack>
      <Stack sx={{ mt: 'auto' }}>
        {rate.map((text, i) => (
          <Typography key={'rate' + i} fontSize={18} textAlign="center">
            {text}
          </Typography>
        ))}
      </Stack>
    </Stack>
  );
}

// Temporary static page for toss payments qualification
export default function Pricing() {
  return (
    <Stack gap={3} sx={{ borderRadius: 6, p: 4, bgcolor: 'white' }}>
      <Typography variant="h4" fontWeight="bold" textAlign="center">
        요금제
      </Typography>
      <Stack direction="row" gap={2}>
        {plans.map((plan) => (
          <PlanCard key={plan.label} title={plan.label} content={plan.content} rate={plan.rateText} />
        ))}
      </Stack>
    </Stack>
  );
}
